import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-av-assignments-div',
  templateUrl: './av-assignments-div.component.html',
  styleUrls: ['./av-assignments-div.component.scss']
})
export class AvAssignmentsDivComponent implements OnInit {

  @Input() title;
  constructor() { }

  ngOnInit(): void {
  }

}
